import styled from 'styled-components';

export default styled.button`
  border-radius: 25px;
  padding: 10px 15px;
  :focus {
    outline:0;
  }
`;
